<template>

  <div class="row">
    <div class="col-12"  v-if="fetchDatasetForPromptsChart(promtChartValues).length">
      <line-non-numeric-y-chart class="row mt-2" v-bind:datasets="fetchDatasetForPromptsChart(promtChartValues)"
                                :chart-id="'promtChart' + stageId + index"
                                :stage-info="stageId"
                                v-bind:y-labels="promtChartLevels"
                                v-bind:scale-label="'report.label_prompt_levels' | trans"
                                v-bind:show-legend="false"
                                v-bind:y-axes-begin-at-zero="true"
                                v-on:popup-show="popupPromptShow"
                                :height="280"
                                :width=null
                                :aspect-ratio=false
      />
      <h4 class="chart__title mb-3">
        {{'report.graph_prompt_levels' | trans }} {{description}}.
      </h4>

      <div v-if="isModalVisible">


        <chart-popup :visible="isModalVisible"
                     :isSimple="isSimple"
                     :isDtt="isDtt"
                     chartType="2"
                     :stimulId="isDtt ? chosenStimul[0].globalTaskId : chosenStimul[0].id"
                     v-on:close="onClose"
                     :stage-id="selectedStageId"
                     :graphTitle="'protocol.stimulus_mastering_chart' | trans"
                     :protocolId="protocolId"
                     :dataPoint="dataPoint">
        </chart-popup>

      </div>
    </div>
  </div>

</template>

<script>
  import {LineNonNumericYChart, LineChartDataset} from '../../../common/chart';
  import values from 'lodash/values';
  import ChartPopup from '../../dashboardParent/components/ChartPopup';
  import forEach from 'lodash/forEach';
  import moment from 'moment';

  export default {
    props: ['promtChartValues', 'promtChartLevels', 'stageId', 'chosenStimul', 'protocolId', 'description', 'index', 'isSimple', 'isDtt'],
    components: {
      LineNonNumericYChart, ChartPopup
    },
    data() {
      return {
        selectedStageId: null,
        dataPoint: null,
        type: null,
        isModalVisible: false,

      }
    },
    computed:{

    },
    created() {
      this.promtChartLevels.push("")
      this.promtChartLevels.unshift(" ")
    },
    methods: {
      fetchDatasetForPromptsChart(dataset){

        let datasetPromptsChart = [];

        forEach (dataset, (dataItem) => {

          let dateChart = !!this.isSimple ? values(dataItem.data) : values(dataItem);

          if(dateChart.length){
            datasetPromptsChart.push(new LineChartDataset({
              data: dateChart,
            }))
          }

        });



        return datasetPromptsChart;

      },


      popupPromptShow(data,stageId){

        if(this.chosenStimul.length === 1){
          this.dataPoint = moment.utc(data.x, 'DD.MM.YYYY').unix();
          this.selectedStageId = stageId;
          this.isModalVisible = true;
        }

      },

      onClose() {
        this.isModalVisible = false;
      },
    }
  }
</script>


// WEBPACK FOOTER //
// src/modules/chart/component/PromptChart.vue